<template>
    <div>
    <van-popup
      v-model:show="self.isShow"
      position="bottom"
      :style="{ height: '40%' }"
    >
            <van-picker
            title="一级来源"
            v-model="sourceValue"
            :columns="columns"
            @confirm="onConfirm"
            @cancel="onCancel"
            @change="onChange"
            />
        </van-popup>

  </div>
</template>

<script>
 import func from "@/util/func.js"
export default {
  name: "step1",
  props: {
    self: {
      type: Object,
      required: false,
      default: () => ({
        isShow: false,
      }),
    },
    optinos:{
        type: Array,
        required: false,
        default: () => ([]),
    }
  },
  components: {},
  data() {
    return {};
  },
  setup(props){
    console.log(props);
    let columns = props.optinos.map((item,index)=>{
        return {
            ...item,
            text:item.name
        }
    })

    let sourceValue = [];
    

    if(!func.isEmpty(props.self.current)){
      sourceValue = [props.self.current];
    }
    return {
        columns,
        sourceValue
    }
  },
  mounted() {},
  methods: {
    onConfirm(value, index) {
      // 确认选择的值和索引
      let that=this;
      console.log('确认:', value, index);
      let item = value.selectedOptions;
      that.$emit('select',item);
      this.self.isShow=false;
    },
    onCancel() {
      // 取消选择
      this.self.isShow=false;
    },
    onChange(value, index) {
      // 选择变化时的值和索引
      console.log('变化:', value, index);
    }

  },
};
</script>

<style>
</style>